/*
 * Traducciones de los enums que llegan crudos (en ingles) desde la API.
 * translate() cae a humanize() si aparece un valor nuevo que aun no esta
 * mapeado, para no romper la UI mientras se actualiza esta lista.
 */
import { humanize } from "./utils";

export function translate(map: Record<string, string>, value: string) {
  return map[value] ?? humanize(value);
}

/* AssignmentStatus, CourseStatus, CertificateStatus, DeliveryStatus, etc. */
export const statusLabels: Record<string, string> = {
  PASSED: "Aprobado",
  VALID: "Valido",
  ACTIVE: "Activo",
  COMPLETED: "Completado",
  DELIVERED: "Entregado",
  READ: "Leido",
  PUBLISHED: "Publicado",
  IN_PROGRESS: "En progreso",
  SENT: "Enviado",
  ASSIGNED: "Asignado",
  EVALUATION_PENDING: "Evaluacion pendiente",
  CONTENT_COMPLETED: "Contenido completo",
  PENDING: "Pendiente",
  DRAFT: "Borrador",
  NOT_STARTED: "No iniciado",
  INACTIVE: "Inactivo",
  ARCHIVED: "Archivado",
  FAILED: "No aprobado",
  EXPIRED: "Vencido",
  REVOKED: "Revocado",
  LOCKED: "Bloqueado",
};

export const roleLabels: Record<string, string> = {
  ADMIN: "Administrador",
  TRAINING_MANAGER: "Responsable de capacitacion",
  INSTRUCTOR: "Instructor",
  PARTICIPANT: "Participante",
  AUDITOR: "Auditor",
};

export const organizationUnitTypeLabels: Record<string, string> = {
  COMPANY: "Empresa",
  AREA: "Area",
  DEPARTMENT: "Departamento",
  BRANCH: "Sucursal",
  POSITION: "Cargo",
  UNIT: "Unidad",
};

export const contentTypeLabels: Record<string, string> = {
  VIDEO: "Video",
  PDF: "PDF",
  WORD: "Word",
  POWERPOINT: "PowerPoint",
  EXCEL: "Excel",
  IMAGE: "Imagen",
  AUDIO: "Audio",
  EXTERNAL_LINK: "Enlace externo",
  HTML: "Contenido HTML",
  DOCUMENT: "Documento institucional",
};

export const questionTypeLabels: Record<string, string> = {
  SINGLE_CHOICE: "Opcion unica",
  MULTIPLE_CHOICE: "Opcion multiple",
  TRUE_FALSE: "Verdadero o falso",
  SHORT_ANSWER: "Respuesta corta",
  MATCHING: "Emparejamiento",
};

export const notificationKindLabels: Record<string, string> = {
  ASSIGNMENT: "Asignacion",
  REMINDER: "Recordatorio",
  DUE_SOON: "Por vencer",
  OVERDUE: "Vencido",
  RESULT: "Resultado",
  CERTIFICATE: "Certificado",
  ANNOUNCEMENT: "Anuncio",
  PASSWORD_RESET: "Restablecimiento de contrasena",
};

export const notificationChannelLabels: Record<string, string> = {
  IN_APP: "En la plataforma",
  EMAIL: "Correo electronico",
  WHATSAPP: "WhatsApp",
};

export const assignmentSourceLabels: Record<string, string> = {
  ADMINISTRATIVE: "Asignacion administrativa",
  SELF_ENROLLMENT: "Autoinscripcion",
  AUTOMATIC: "Asignacion automatica",
};

export const auditActionLabels: Record<string, string> = {
  CREATE: "Creacion",
  UPDATE: "Actualizacion",
  DELETE: "Eliminacion",
  LOGIN: "Inicio de sesion",
  LOGOUT: "Cierre de sesion",
  ASSIGN: "Asignacion",
  ENROLL: "Inscripcion",
  PUBLISH: "Publicacion",
  OPEN: "Apertura",
  CONFIRM: "Confirmacion",
  START: "Inicio",
  COMPLETE: "Finalizacion",
  SUBMIT: "Envio",
  GENERATE: "Generacion",
  DOWNLOAD: "Descarga",
  NOTIFY: "Notificacion",
  VIEW: "Visualizacion",
  ISSUE: "Emision",
  REVOKE: "Revocacion",
  IMPORT: "Importacion",
  EXPORT: "Exportacion",
};
